<kendo-dialog title="{{ constantHelper.LBL_COMMON_WARNING | translate}}" *ngIf="isAlertOpen" (close)="close()" [minWidth]="250" [width]="450">
  <p class="message">{{ message }}</p>
  <div class="dialog-actions">
    <button class="btn btn-primary" (click)="close()">{{ constantHelper.LBL_COMMON_OK | translate}}</button>
  </div>
</kendo-dialog>

